// extracted by mini-css-extract-plugin
export var clauseRow = "_b6-6";
export var emptyState = "_b6-d";
export var filterContent = "_b6-a";
export var filterGroup = "_b6-1";
export var filterGroupContainer = "_b6-0";
export var nestedGroup = "_b6-2";
export var nestedGroupContent = "_b6-b";
export var nestedGroupDepth1 = "_b6-3";
export var nestedGroupDepth2 = "_b6-4";
export var nestedGroupDepth3 = "_b6-5";
export var nestedGroupEmpty = "_b6-c";
export var operatorAnd = "_b6-8";
export var operatorOr = "_b6-9";
export var operatorToggle = "_b6-7";
export var removeGroupButton = "_b6-e";